import { hasAnyCompanyTypes } from 'lib/functions/utils';
import { User } from 'services/redux/authSlice';

export function hasAnySettingsUsersCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, ['FinancingHub', 'CreditHubPro']);
}

export function hasAnySettingsProductsCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, ['FinancingHub', 'CreditHubPro']);
}

export function hasAnySettingsRiskCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, ['FinancingHub', 'CreditHubPro']);
}

export function hasAnySettingsFinanceCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, ['FinancingHub', 'Accountant']);
}

export function hasAnySettingsSiiCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, [
    'FinancingHub',
    'Accountant',
    'CreditHubPro',
  ]);
}

export function hasAnySettingsTagsCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, [
    'FinancingHub',
    'Accountant',
    'CreditHubPro',
  ]);
}

export function hasAnySettingsAccountingCompanyType(user: User | undefined) {
  return hasAnyCompanyTypes(user, [
    'FinancingHub',
    'Accountant',
    'CreditHubPro',
  ]);
}

export function hasAnySettingsContractsCompanyType(_user: User | undefined) {
  // return hasAnyCompanyTypes(user, []);
  return true;
}
